const defaultJobs = [
  {
    id: 1,
    title: 'Full Stack Developer',
    postedDate: '2025-06-01',
    closingDate: '2025-07-01',
    location: 'Stamford, CT, USA',
    description: 'We are looking for an experienced Full Stack Developer with expertise in React, Node.js, and database technologies to join our growing team.',
  },
  {
    id: 2,
    title: 'Digital Marketing Specialist',
    postedDate: '2025-06-05',
    closingDate: '2025-07-05',
    location: 'Chennai, India',
    description: 'Seeking a Digital Marketing Specialist with experience in SEO, SEM, Social Media Marketing, and Content Strategy.',
  },
];

export const getJobs = () => {
  const stored = localStorage.getItem('egb_jobs');
  return stored ? JSON.parse(stored) : defaultJobs;
};

export const saveJobs = (jobs) => {
  localStorage.setItem('egb_jobs', JSON.stringify(jobs));
};
